import { i18n } from '../i18nType';

export const LANDING_PAGE_HEADER: i18n = {
  en: 'Material Management System'
};
export const LOGOUT_BUTTON: i18n = { en: 'Log Out' };
